/**
 * Admin CompanyCam sidebar configuration
 */
export default {
  items: [
    {
      label: 'API keys',
      href: '/admin/company_cam/api_keys',
      icon: 'fa-solid fa-key',
      activeUrl: '/admin/company_cam/api_keys'
    }
  ]
}
